import React from 'react';
import * as PropTypes from 'prop-types';

export const BarsLoader = () => {
  return (
    <div className="ct-bars-loader">
      <div className="bar" />
      <div className="bar" />
      <div className="bar" />
      <div className="bar" />
      <div className="bar" />
      <div className="bar" />
    </div>
  );
};

export const BlockUi = ({ show, children }) => (
  <div className="ct-block-ui" style={{ display: show ? 'flex' : 'none' }}>
    <div className="ct-block-ui__wrapper">{children || <BarsLoader />}</div>
  </div>
);

BlockUi.propTypes = {
  show: PropTypes.bool.isRequired,
};
